import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';
@Injectable({
  providedIn: 'root'
})
export class EmailsLogService {
  constructor(private httpService: HttpService) { }
  getEmailsLog(paramData) {
    var request = {
      URL: "emailsUpsiLog",
      DATA: paramData
    }
    return this.httpService.post(request);
  }
}
